// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.high-court-case-form-container {
  min-height: 100vh;
  background: #f9fafb;
  padding: 2rem;
}
.high-court-case-form-container .case-type-fetch-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin: 0 auto 1rem auto;
}
.high-court-case-form-container .case-type-fetch-section .fetch-section-title {
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.high-court-case-form-container .case-type-fetch-section .fetch-input-group {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}
@media (max-width: 768px) {
  .high-court-case-form-container .case-type-fetch-section .fetch-input-group {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
}
.high-court-case-form-container .case-type-fetch-section .fetch-input-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.high-court-case-form-container .case-type-fetch-section .fetch-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.high-court-case-form-container .case-type-fetch-section .fetch-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
}
.high-court-case-form-container .case-type-fetch-section .fetch-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.high-court-case-form-container .case-type-fetch-section .fetch-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.high-court-case-form-container .case-type-fetch-section .fetch-input::placeholder {
  color: #9ca3af;
}
.high-court-case-form-container .case-type-fetch-section .fetch-details-btn {
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  min-width: 140px;
  transition: background-color 0.2s;
  height: fit-content;
}
.high-court-case-form-container .case-type-fetch-section .fetch-details-btn:hover:not(:disabled) {
  background-color: #0052a3;
}
.high-court-case-form-container .case-type-fetch-section .fetch-details-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.high-court-case-form-container .case-type-fetch-section .fetch-details-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
@media (max-width: 768px) {
  .high-court-case-form-container .case-type-fetch-section .fetch-details-btn {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .high-court-case-form-container .case-type-fetch-section {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
}
.high-court-case-form-container .case-type-input-group {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}
.high-court-case-form-container .case-type-input-group input {
  flex: 1 1;
}
.high-court-case-form-container .case-type-input-group .fetch-details-btn {
  padding: 0.5rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  min-width: 120px;
  transition: background-color 0.2s;
}
.high-court-case-form-container .case-type-input-group .fetch-details-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.high-court-case-form-container .case-type-input-group .fetch-details-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
@media (max-width: 768px) {
  .high-court-case-form-container .case-type-input-group {
    flex-direction: column;
    gap: 0.5rem;
  }
  .high-court-case-form-container .case-type-input-group .fetch-details-btn {
    min-width: auto;
    width: 100%;
  }
}
.high-court-case-form-container .court-remove-case {
  padding: 0.5rem 1rem;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.high-court-case-form-container .court-remove-case:hover {
  background-color: #dc2626;
}
.high-court-case-form-container .court-add-case {
  padding: 0.5rem 1rem;
  background-color: #5cb85c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 0.5rem;
}
.high-court-case-form-container .court-add-case:hover {
  background-color: #16a34a;
}
.high-court-case-form-container .rem-div-btn,
.high-court-case-form-container .add-div-btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
@media (max-width: 768px) {
  .high-court-case-form-container {
    padding: 1rem;
  }
}
.high-court-case-form-container .hc-form-header {
  text-align: center;
  margin-bottom: 2rem;
}
.high-court-case-form-container .hc-form-header .hc-form-title {
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .high-court-case-form-container .hc-form-header .hc-form-title {
    font-size: 1.25rem;
  }
}
.high-court-case-form-container .hc-form-header .hc-form-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 400;
}
.high-court-case-form-container form {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin: auto;
}
.high-court-case-form-container form h2 {
  font-weight: 500;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  font-size: 1rem;
}
@media (max-width: 768px) {
  .high-court-case-form-container form {
    padding: 1rem;
    margin: 1rem;
  }
}
.high-court-case-form-container .div-rem {
  background: #f9fafb;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #f3f4f6;
  transition: all 0.3s ease-in-out;
}
.high-court-case-form-container .div-rem.collapsed {
  padding: 0.75rem 1rem;
  margin-bottom: 0.75rem;
}
.high-court-case-form-container .div-rem:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .high-court-case-form-container .div-rem {
    padding: 0.75rem;
  }
}
.high-court-case-form-container .high-court-form-group {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.high-court-case-form-container .high-court-form-group:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .high-court-case-form-container .high-court-form-group {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.high-court-case-form-container .high-court-form-group .form-det {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.high-court-case-form-container .high-court-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.high-court-case-form-container .high-court-form-group label .user-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.high-court-case-form-container .high-court-form-group input,
.high-court-case-form-container .high-court-form-group textarea,
.high-court-case-form-container .high-court-form-group select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.high-court-case-form-container .high-court-form-group input:focus,
.high-court-case-form-container .high-court-form-group textarea:focus,
.high-court-case-form-container .high-court-form-group select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.high-court-case-form-container .high-court-form-group input:hover:not(:focus),
.high-court-case-form-container .high-court-form-group textarea:hover:not(:focus),
.high-court-case-form-container .high-court-form-group select:hover:not(:focus) {
  border-color: #9ca3af;
}
.high-court-case-form-container .high-court-form-group input::placeholder,
.high-court-case-form-container .high-court-form-group textarea::placeholder,
.high-court-case-form-container .high-court-form-group select::placeholder {
  color: #9ca3af;
}
.high-court-case-form-container .high-court-form-group input:disabled,
.high-court-case-form-container .high-court-form-group textarea:disabled,
.high-court-case-form-container .high-court-form-group select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.high-court-case-form-container .high-court-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.high-court-case-form-container .high-court-form-group input[type=date] {
  cursor: pointer;
}
.high-court-case-form-container .high-court-form-group input[type=date]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}
.high-court-case-form-container .high-court-form-group input[type=date]::-webkit-calendar-picker-indicator:hover {
  opacity: 0.8;
}
.high-court-case-form-container .high-court-form-group textarea {
  height: auto;
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.high-court-case-form-container .order-summary-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.high-court-case-form-container .order-summary-view .summary-details {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
}
.high-court-case-form-container .order-summary-view .summary-details .summary-item {
  display: flex;
  gap: 0.35rem;
}
.high-court-case-form-container .order-summary-view .summary-details .summary-label {
  color: #6b7280;
  font-weight: 500;
}
.high-court-case-form-container .order-summary-view .summary-details .summary-value {
  color: #111827;
  font-weight: 400;
}
.high-court-case-form-container .order-summary-view .summary-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.high-court-case-form-container .order-summary-view .summary-actions .edit-btn {
  padding: 0.5rem 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.high-court-case-form-container .order-summary-view .summary-actions .edit-btn:hover {
  background-color: #2563eb;
}
.high-court-case-form-container .form-row {
  margin-bottom: 1rem;
}
.high-court-case-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .high-court-case-form-container .form-row .high-court-form-group {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.high-court-case-form-container .hc-submit-section {
  display: flex;
  justify-content: end;
  margin-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .high-court-case-form-container .hc-submit-section {
    flex-direction: column;
  }
}
.high-court-case-form-container .hc-submit-section .submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin-top: 1rem;
  display: block;
}
.high-court-case-form-container .hc-submit-section .submit-btn:hover {
  background-color: #005a9a;
}
.high-court-case-form-container .hc-submit-section .submit-btn:active {
  transform: translateY(1px);
}
.high-court-case-form-container .hc-submit-section .submit-btn:focus {
  outline: none;
}
.high-court-case-form-container .hc-submit-section .submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .high-court-case-form-container .hc-submit-section .submit-btn {
    width: 100%;
    margin-top: 1rem;
  }
}
.high-court-case-form-container .main-content {
  padding-bottom: 120px;
}
@media (max-width: 768px) {
  .high-court-case-form-container .main-content {
    padding-bottom: 100px;
  }
}
.high-court-case-form-container .hc-empty-state {
  text-align: center;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  border: 2px dashed #e5e7eb;
  margin-bottom: 1rem;
}
.high-court-case-form-container .hc-empty-state .hc-empty-text {
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.high-court-case-form-container .hc-array-actions {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn,
.high-court-case-form-container .hc-array-actions .hc-remove-btn {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-add-btn,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-add-btn {
  background-color: #5cb85c;
  color: white;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-add-btn:hover,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-add-btn:hover {
  background-color: #16a34a;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-remove-btn,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-remove-btn {
  background-color: #e74c3c;
  color: white;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-remove-btn:hover,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-remove-btn:hover {
  background-color: #dc2626;
}

.hc-submit-section-top {
  position: fixed;
  bottom: 2rem;
  left: 88.2%;
  transform: translateX(-151.5%);
  z-index: 1000;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.hc-submit-section-top .hc-scroll-btns {
  display: flex;
  gap: 10px;
}
.hc-submit-section-top .hc-scroll-btns .scroll-arrow-btn {
  width: 30px;
  height: 30px;
  background-color: #6b7280;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hc-submit-section-top .hc-scroll-btns .scroll-arrow-btn:hover {
  background-color: #4b5563;
  transform: scale(1.1);
}
.hc-submit-section-top .hc-scroll-btns .scroll-arrow-btn:active {
  transform: scale(0.95);
}
.hc-submit-section-top .submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin: 0 auto;
  display: block;
}
.hc-submit-section-top .submit-btn:hover {
  background-color: #005a9a;
}
.hc-submit-section-top .submit-btn:active {
  transform: translateY(0);
}
.hc-submit-section-top .submit-btn:focus {
  outline: none;
}
.hc-submit-section-top .submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}
.hc-submit-section-top .submit-btn:disabled:hover {
  transform: none;
}
@media (max-width: 768px) {
  .hc-submit-section-top {
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    transform: none;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .hc-submit-section-top .scroll-arrow-btn {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
  .hc-submit-section-top .submit-btn {
    flex: 1 1;
    margin: 0 0.5rem;
    border-radius: 25px;
    min-width: unset;
    font-size: 0.95rem;
    padding: 0.875rem 1.25rem;
  }
}

@media (max-width: 1024px) {
  .high-court-case-form-container .high-court-form-group {
    flex-direction: column;
    gap: 0.5rem;
  }
}
@media (max-width: 480px) {
  .high-court-case-form-container {
    padding: 0.5rem;
  }
  .high-court-case-form-container form {
    padding: 1rem;
    margin: 0.5rem;
  }
  .high-court-case-form-container .hc-form-header .hc-form-title {
    font-size: 1.125rem;
  }
  .high-court-case-form-container .high-court-form-group input,
  .high-court-case-form-container .high-court-form-group textarea,
  .high-court-case-form-container .high-court-form-group select {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .high-court-case-form-container .submit-btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;
  }
}
form {
  animation: hc-fade-in 0.3s ease-out;
}

@keyframes hc-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media print {
  .high-court-case-form-container {
    background: white;
    padding: 0;
  }
  .high-court-case-form-container form {
    box-shadow: none;
    border: 1px solid #000;
  }
  .high-court-case-form-container .submit-btn,
  .high-court-case-form-container .rem-div-btn,
  .high-court-case-form-container .add-div-btn,
  .high-court-case-form-container .fetch-details-btn {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/HighCourtCaseForm/HighCourtCaseForm.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;AACF;AACE;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,wBAAA;AACJ;AACI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AACN;AAEI;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAAN;AAEM;EALF;IAMI,sBAAA;IACA,oBAAA;IACA,YAAA;EACN;AACF;AAEI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAAN;AAGI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AADN;AAII;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AAFN;AAIM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAFR;AAKM;EACE,qBAAA;AAHR;AAMM;EACE,cAAA;AAJR;AAQI;EACE,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AANN;AAQM;EACE,yBAAA;AANR;AASM;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAPR;AAUM;EACE,aAAA;EACA,6CAAA;AARR;AAWM;EA7BF;IA8BI,WAAA;EARN;AACF;AAWI;EAvGF;IAwGI,aAAA;IACA,qBAAA;EARJ;AACF;AAWE;EACE,aAAA;EACA,WAAA;EACA,oBAAA;AATJ;AAWI;EACE,SAAA;AATN;AAYI;EACE,oBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AAVN;AAYM;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAVR;AAaM;EACE,aAAA;EACA,6CAAA;AAXR;AAeI;EAlCF;IAmCI,sBAAA;IACA,WAAA;EAZJ;EAcI;IACE,eAAA;IACA,WAAA;EAZN;AACF;AAiBE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAfJ;AAiBI;EACE,yBAAA;AAfN;AAmBE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAjBJ;AAmBI;EACE,yBAAA;AAjBN;AAsBE;;EAEE,aAAA;EACA,yBAAA;EACA,kBAAA;AApBJ;AAuBE;EAvMF;IAwMI,aAAA;EApBF;AACF;AAsBE;EACE,kBAAA;EACA,mBAAA;AApBJ;AAsBI;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AApBN;AAsBM;EALF;IAMI,kBAAA;EAnBN;AACF;AAsBI;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AApBN;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,YAAA;AAtBJ;AAwBI;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;EACA,eAAA;AAtBN;AAyBI;EAlBF;IAmBI,aAAA;IACA,YAAA;EAtBJ;AACF;AAyBE;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AAvBJ;AAyBI;EACE,qBAAA;EACA,sBAAA;AAvBN;AA0BI;EACE,gBAAA;AAxBN;AA2BI;EAjBF;IAkBI,gBAAA;EAxBJ;AACF;AA2BE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,gBAAA;AAzBN;AA4BI;EATF;IAUI,sBAAA;IACA,WAAA;EAzBJ;AACF;AA2BI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAzBN;AA4BI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA1BN;AA2BM;EACE,cAAA;EACA,oBAAA;AAzBR;AA6BI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA3BN;AA6BM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAzBR;AA4BM;;;EACE,qBAAA;AAxBR;AA2BM;;;EACE,cAAA;AAvBR;AA0BM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAtBR;AA0BI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAxBN;AA2BI;EACE,eAAA;AAzBN;AA2BM;EACE,eAAA;EACA,YAAA;AAzBR;AA2BQ;EACE,YAAA;AAzBV;AA8BI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA5BN;AAgCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA9BN;AAgCM;EACI,aAAA;EACA,YAAA;AA9BV;AAiCM;EACE,cAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,cAAA;EACA,gBAAA;AAhCR;AAoCI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAlCN;AAoCM;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;AAlCR;AAoCQ;EACE,yBAAA;AAlCV;AAwCE;EACE,mBAAA;AAtCJ;AAwCI;EACE,gBAAA;AAtCN;AAyCI;EACE;IACE,sBAAA;IACA,WAAA;EAvCN;AACF;AA2CE;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,6BAAA;AAzCJ;AA2CI;EANF;IAOI,sBAAA;EAxCJ;AACF;AA0CI;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAxCN;AA0CM;EACE,yBAAA;AAxCR;AA2CM;EACE,0BAAA;AAzCR;AA4CM;EACE,aAAA;AA1CR;AA6CM;EACE,YAAA;EACA,mBAAA;AA3CR;AA8CM;EA9BF;IA+BI,WAAA;IACA,gBAAA;EA3CN;AACF;AA+CE;EACE,qBAAA;AA7CJ;AA+CI;EAHF;IAII,qBAAA;EA5CJ;AACF;AA+CE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;AA7CJ;AA+CI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AA7CN;AAiDE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AA/CJ;AAiDI;;EAEE,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AA/CN;AAiDM;;EACE,yBAAA;EACA,YAAA;AA9CR;AAgDQ;;EACE,yBAAA;AA7CV;AAiDM;;EACE,yBAAA;EACA,YAAA;AA9CR;AAgDQ;;EACE,yBAAA;AA7CV;;AAoDA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAjDF;AAmDE;EACE,aAAA;EACA,SAAA;AAjDJ;AAkDI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhDN;AAkDM;EACE,yBAAA;EACA,qBAAA;AAhDR;AAmDM;EACE,sBAAA;AAjDR;AAsDE;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AApDJ;AAsDK;EACC,yBAAA;AApDN;AAuDI;EACE,wBAAA;AArDN;AAwDI;EACE,aAAA;AAtDN;AAyDI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAvDN;AAyDM;EACE,eAAA;AAvDR;AA4DE;EA7EF;IA8EI,YAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;EAzDF;EA2DE;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAzDJ;EA4DE;IACE,SAAA;IACA,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,yBAAA;EA1DJ;AACF;;AA8DA;EAEI;IACE,sBAAA;IACA,WAAA;EA5DJ;AACF;AAgEA;EACE;IACE,eAAA;EA9DF;EAgEE;IACE,aAAA;IACA,cAAA;EA9DJ;EAiEE;IACE,mBAAA;EA/DJ;EAmEI;;;IAGE,iBAAA;IACA,oBAAA;EAjEN;EAqEE;IACE,yBAAA;IACA,oBAAA;EAnEJ;AACF;AAuEA;EACE,mCAAA;AArEF;;AAwEA;EACE;IACE,UAAA;IACA,2BAAA;EArEF;EAwEA;IACE,UAAA;IACA,wBAAA;EAtEF;AACF;AAyEA;EACE;IACE,iBAAA;IACA,UAAA;EAvEF;EAyEE;IACE,gBAAA;IACA,sBAAA;EAvEJ;EA0EE;;;;IAIE,aAAA;EAxEJ;AACF","sourcesContent":[".high-court-case-form-container {\r\n  min-height: 100vh;\r\n  background: #f9fafb;\r\n  padding: 2rem;\r\n\r\n  .case-type-fetch-section {\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 0.375rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    padding: 1.5rem;\r\n    margin: 0 auto 1rem auto;\r\n\r\n    .fetch-section-title {\r\n      font-size: 1rem;\r\n      color: #374151;\r\n      font-weight: 500;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n    }\r\n\r\n    .fetch-input-group {\r\n      display: flex;\r\n      gap: 1rem;\r\n      align-items: flex-end;\r\n\r\n      @media (max-width: 768px) {\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n        gap: 0.75rem;\r\n      }\r\n    }\r\n\r\n    .fetch-input-wrapper {\r\n      flex: 1;\r\n      display: flex;\r\n      flex-direction: column;\r\n    }\r\n\r\n    .fetch-label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n    }\r\n\r\n    .fetch-input {\r\n      width: 100%;\r\n      padding: 0.75rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n    }\r\n\r\n    .fetch-details-btn {\r\n      padding: 0.75rem 1.5rem;\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      white-space: nowrap;\r\n      min-width: 140px;\r\n      transition: background-color 0.2s;\r\n      height: fit-content;\r\n\r\n      &:hover:not(:disabled) {\r\n        background-color: #0052a3;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #9ca3af;\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      margin-bottom: 1.5rem;\r\n    }\r\n  }\r\n\r\n  .case-type-input-group {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    align-items: stretch;\r\n\r\n    input {\r\n      flex: 1;\r\n    }\r\n\r\n    .fetch-details-btn {\r\n      padding: 0.5rem 1rem;\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      white-space: nowrap;\r\n      min-width: 120px;\r\n      transition: background-color 0.2s;\r\n\r\n      &:disabled {\r\n        background-color: #9ca3af;\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n\r\n      .fetch-details-btn {\r\n        min-width: auto;\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n  \r\n  // <-- MODIFIED: Button styles are now independent for reusability -->\r\n  .court-remove-case {\r\n    padding: 0.5rem 1rem;\r\n    background-color: #e74c3c;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      background-color: #dc2626;\r\n    }\r\n  }\r\n\r\n  .court-add-case {\r\n    padding: 0.5rem 1rem;\r\n    background-color: #5cb85c;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    margin-top: 0.5rem;\r\n\r\n    &:hover {\r\n      background-color: #16a34a;\r\n    }\r\n  }\r\n\r\n  // <-- MODIFIED: These containers are now just for layout -->\r\n  .rem-div-btn,\r\n  .add-div-btn {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .hc-form-header {\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n    \r\n    .hc-form-title {\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin-bottom: 0.5rem;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n\r\n    .hc-form-subtitle {\r\n      font-size: 0.875rem;\r\n      color: #6b7280;\r\n      font-weight: 400;\r\n    }\r\n  }\r\n\r\n  form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 1.5rem;\r\n    background-color: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 0.375rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    margin:auto;\r\n\r\n    h2 {\r\n      font-weight: 500;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n      font-size: 1rem;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      margin: 1rem;\r\n    }\r\n  }\r\n\r\n  .div-rem {\r\n    background: #f9fafb;\r\n    border-radius: 0.375rem;\r\n    padding: 1rem;\r\n    margin-bottom: 1rem;\r\n    border: 1px solid #f3f4f6;\r\n    transition: all 0.3s ease-in-out;\r\n\r\n    &.collapsed {\r\n      padding: 0.75rem 1rem;\r\n      margin-bottom: 0.75rem;\r\n    }\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 0.75rem;\r\n    }\r\n  }\r\n\r\n  .high-court-form-group {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    .form-det {\r\n      flex: 1;\r\n      display: flex;\r\n      flex-direction: column;\r\n    }\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n      .user-form-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n    input,\r\n    textarea,\r\n    select {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      height: 2.5rem;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #f9fafb;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    select {\r\n      appearance: none;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 0.5rem center;\r\n      background-repeat: no-repeat;\r\n      background-size: 1.5rem 1.5rem;\r\n      padding-right: 2.5rem;\r\n    }\r\n\r\n    input[type=\"date\"] {\r\n      cursor: pointer;\r\n\r\n      &::-webkit-calendar-picker-indicator {\r\n        cursor: pointer;\r\n        opacity: 0.6;\r\n\r\n        &:hover {\r\n          opacity: 0.8;\r\n        }\r\n      }\r\n    }\r\n\r\n    textarea {\r\n      height: auto;\r\n      min-height: 4rem;\r\n      resize: vertical;\r\n      line-height: 1.5;\r\n    }\r\n  }\r\n  \r\n  .order-summary-view {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    gap: 1rem;\r\n\r\n    .summary-details {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 1rem;\r\n      flex-wrap: wrap;\r\n      font-size: 0.875rem;\r\n\r\n      .summary-item {\r\n          display: flex;\r\n          gap: 0.35rem;\r\n      }\r\n\r\n      .summary-label {\r\n        color: #6b7280;\r\n        font-weight: 500;\r\n      }\r\n\r\n      .summary-value {\r\n        color: #111827;\r\n        font-weight: 400;\r\n      }\r\n    }\r\n\r\n    .summary-actions {\r\n      display: flex;\r\n      gap: 0.5rem;\r\n      align-items: center;\r\n\r\n      .edit-btn {\r\n        padding: 0.5rem 1rem;\r\n        background-color: #3b82f6;\r\n        color: white;\r\n        border: none;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        white-space: nowrap;\r\n        transition: background-color 0.2s;\r\n\r\n        &:hover {\r\n          background-color: #2563eb;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-row {\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      .high-court-form-group {\r\n        flex-direction: column;\r\n        gap: 0.5rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .hc-submit-section {\r\n    display: flex;\r\n    justify-content: end;\r\n    margin-top: 1.5rem;\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n    }\r\n\r\n    .submit-btn {\r\n      padding: 0.75rem 1rem;\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.25rem;\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      min-width: 150px;\r\n      margin-top: 1rem;\r\n      display: block;\r\n\r\n      &:hover {\r\n        background-color: #005a9a;\r\n      }\r\n\r\n      &:active {\r\n        transform: translateY(1px);\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n\r\n      &:disabled {\r\n        opacity: 0.6;\r\n        cursor: not-allowed;\r\n      }\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n        margin-top: 1rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .main-content {\r\n    padding-bottom: 120px;\r\n\r\n    @media (max-width: 768px) {\r\n      padding-bottom: 100px;\r\n    }\r\n  }\r\n\r\n  .hc-empty-state {\r\n    text-align: center;\r\n    padding: 2rem;\r\n    background: #f9fafb;\r\n    border-radius: 0.375rem;\r\n    border: 2px dashed #e5e7eb;\r\n    margin-bottom: 1rem;\r\n\r\n    .hc-empty-text {\r\n      color: #6b7280;\r\n      font-style: italic;\r\n      font-size: 0.875rem;\r\n    }\r\n  }\r\n\r\n  .hc-array-actions {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    .hc-add-btn,\r\n    .hc-remove-btn {\r\n      padding: 0.375rem 0.75rem;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      border: none;\r\n\r\n      &.hc-add-btn {\r\n        background-color: #5cb85c;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #16a34a;\r\n        }\r\n      }\r\n\r\n      &.hc-remove-btn {\r\n        background-color: #e74c3c;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #dc2626;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.hc-submit-section-top {\r\n  position: fixed;\r\n  bottom: 2rem;\r\n  left: 88.2%;\r\n  transform: translateX(-151.5%);\r\n  z-index: 1000;\r\n  transition: opacity 0.3s ease;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n\r\n  .hc-scroll-btns {\r\n    display: flex;\r\n    gap: 10px;\r\n    .scroll-arrow-btn {\r\n      width: 30px;\r\n      height: 30px;\r\n      background-color: #6b7280;\r\n      color: white;\r\n      border: none;\r\n      border-radius: 50%;\r\n      font-size: 1rem;\r\n      font-weight: bold;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n\r\n      &:hover {\r\n        background-color: #4b5563;\r\n        transform: scale(1.1);\r\n      }\r\n\r\n      &:active {\r\n        transform: scale(0.95);\r\n      }\r\n    }\r\n  }\r\n\r\n  .submit-btn {\r\n    padding: 0.75rem 1rem;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    min-width: 150px;\r\n    margin: 0 auto;\r\n    display: block;\r\n\r\n     &:hover {\r\n      background-color: #005a9a;\r\n    }\r\n\r\n    &:active {\r\n      transform: translateY(0);\r\n    }\r\n\r\n    &:focus {\r\n      outline: none;\r\n    }\r\n\r\n    &:disabled {\r\n      opacity: 0.7;\r\n      cursor: not-allowed;\r\n      transform: none;\r\n\r\n      &:hover {\r\n        transform: none;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    bottom: 1rem;\r\n    left: 1rem;\r\n    right: 1rem;\r\n    transform: none;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    .scroll-arrow-btn {\r\n      width: 35px;\r\n      height: 35px;\r\n      font-size: 1rem;\r\n    }\r\n\r\n    .submit-btn {\r\n      flex: 1;\r\n      margin: 0 0.5rem;\r\n      border-radius: 25px;\r\n      min-width: unset;\r\n      font-size: 0.95rem;\r\n      padding: 0.875rem 1.25rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .high-court-case-form-container {\r\n    .high-court-form-group {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .high-court-case-form-container {\r\n    padding: 0.5rem;\r\n\r\n    form {\r\n      padding: 1rem;\r\n      margin: 0.5rem;\r\n    }\r\n\r\n    .hc-form-header .hc-form-title {\r\n      font-size: 1.125rem;\r\n    }\r\n\r\n    .high-court-form-group {\r\n      input,\r\n      textarea,\r\n      select {\r\n        padding: 0.375rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n\r\n    .submit-btn {\r\n      padding: 0.375rem 0.75rem;\r\n      font-size: 0.8125rem;\r\n    }\r\n  }\r\n}\r\n\r\nform {\r\n  animation: hc-fade-in 0.3s ease-out;\r\n}\r\n\r\n@keyframes hc-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@media print {\r\n  .high-court-case-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    form {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .submit-btn,\r\n    .rem-div-btn,\r\n    .add-div-btn,\r\n    .fetch-details-btn {\r\n      display: none;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
